<script>
  export default {
    name: "ModalValor",
    props: {
      data: {
				type: Object,
				required: true
			}
    },
  };
</script>

<template>
  <div
    class="modal fade"
    id="modal-valor"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal__dialog justify-content-center modal-lg modal-dialog-centered">
      <div class="modal-content modal__content modal-content--cultura">
        <div class="modal-header modal__header">
          <img
            v-if="/.jpg|.jpeg|.png/.test(data.imagen_url)"
            :src="data.imagen_url"
            class="modal__icono"
            alt="Ícono de valor"
          />
          <img
            v-else
            src="@/assets/img/intranet/cultura/img-default-twu.png"
            class="modal__icono"
            alt="Ícono de valor"
          />
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body text-center pt-5">
          <h3 
            class="font-700"
            :style="`color:${data.color}`"
          >
            {{ data.nombre }}
          </h3>
          <p class="modal__parrafo-valor">
            {{ data.descripcion }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>